import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import FactoryNumberBonds from '@/numberQuestionFactories/numberBonds'
import FactoryTimesTables from '@/numberQuestionFactories/timesTables'
import FactoryPowerTen from '@/numberQuestionFactories/powerTen'
import FactoryAddSubtract from '@/numberQuestionFactories/addSubtract'
import FactoryMore from '@/numberQuestionFactories/more'

export type NumberBondsFactory = typeof FactoryNumberBonds
export type TimesTablesFactory = typeof FactoryTimesTables
export type PowerTenFactory = typeof FactoryPowerTen
export type AddSubtractFactory = typeof FactoryAddSubtract
export type MoreFactory = typeof FactoryMore

export type NumberQuestionFactory = NumberBondsFactory | TimesTablesFactory | PowerTenFactory | AddSubtractFactory | MoreFactory

@Component
export default class NumberGameHelper extends Vue {
  protected getQuestionFactory (key: string) : NumberQuestionFactory | null {
    const keyParts = key.split('_')
    const gameType = keyParts[0]
    if (gameType === 'numberBonds') {
      const factory = FactoryNumberBonds
      factory.numbers = keyParts[1]
      factory.operations = keyParts[2]
      return factory
    }
    if (gameType === 'timesTables') {
      const factory = FactoryTimesTables
      factory.related = false
      factory.questions = []
      factory.numbers = keyParts[1]
      factory.operations = keyParts[2]
      if (keyParts.length > 3) {
        if (keyParts[3] === 'related') {
          factory.related = true
        } else if (keyParts[3] === 'relateddecimals') {
          factory.related = true
          factory.decimals = true
        } else if (keyParts[3] === 'mtc') {
          factory.generate()
        }
      }
      return factory
    }
    if (gameType === 'powerTen') {
      const factory = FactoryPowerTen
      factory.numbers = keyParts[1]
      factory.operations = keyParts[2]
      factory.decimals = false
      return factory
    }
    if (gameType === 'powerTenDecimals') {
      const factory = FactoryPowerTen
      factory.numbers = keyParts[1]
      factory.operations = keyParts[2]
      factory.decimals = true
      return factory
    }
    if (gameType === 'addSubtract') {
      const factory = FactoryAddSubtract
      factory.numbers = keyParts[1]
      factory.operations = keyParts[2]
      if (keyParts.length === 4 && keyParts[3] === 'within') {
        factory.within = true
      }
      return factory
    }
    if (gameType === 'more') {
      const factory = FactoryMore
      factory.numbers = keyParts[1]
      factory.operations = keyParts[2]
      return factory
    }
    return null
  }
  // const keyParts = this.key.split('_')
  // switch (keyParts[0]) {
  //   case 'numberBonds':
  //     this.questionFactory = FactoryNumberBonds
  //     this.questionFactory.numbers = keyParts[1]
  //     this.questionFactory.operations = keyParts[2]
  //     break
  //   case 'timesTables':
  //     this.questionFactory = FactoryTimesTables

  //     this.questionFactory.related = false
  //     this.questionFactory.decimals
  //     this.questionFactory.questions = []

  //     this.questionFactory.numbers = keyParts[1]
  //     this.questionFactory.operations = keyParts[2]

  //     if (keyParts.length > 3) {
  //       if (keyParts[3] === 'related') {
  //         this.questionFactory.related = true
  //       } else if (keyParts[3] === 'relateddecimals') {
  //         this.questionFactory.related = true
  //         this.questionFactory.decimals = true
  //       } else if (keyParts[3] === 'mtc') {
  //         this.questionFactory.generate()
  //       }
  //     }
  //     break
  //   case 'powerTen':
  //     this.questionFactory = FactoryPowerTen
  //     this.questionFactory.numbers = keyParts[1]
  //     this.questionFactory.operations = keyParts[2]
  //     this.questionFactory.decimals = false
  //     break
  //   case 'powerTenDecimals':
  //     this.questionFactory = FactoryPowerTen
  //     this.questionFactory.numbers = keyParts[1]
  //     this.questionFactory.operations = keyParts[2]
  //     this.questionFactory.decimals = true
  //     break
  //   case 'addSubtract':
  //     this.questionFactory = FactoryAddSubtract
  //     this.questionFactory.numbers = keyParts[1]
  //     this.questionFactory.operations = keyParts[2]
  //     if (keyParts.length === 4 && keyParts[3] === 'within') {
  //       this.questionFactory.within = true
  //     }
  //     break
  //   case 'more':
  //     this.questionFactory = FactoryMore
  //     this.questionFactory.numbers = keyParts[1]
  //     this.questionFactory.operations = keyParts[2]
  // }
}
